// Stepts for homepage
const onboardingChecklistSteps = [
{
    element: ".table-responsive",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začíname',
        description: '<b>Na tejto stránke máš prehľad o všetkých interných úlohách, ktoré je potrebné sprocesovať v rámci preboardingu a onboardingu zamestnancov.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: 'Úlohy sa ti na túto stránku prepisujú samé, stačí si ich pri jednotlivých zamestnancoch zvoliť. Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> sa preklikneš na zamestnanca, ku ktorému úloha patrí. 👌',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'image-popover',
        title: '<a href="/onboarding/stranka?id=1&job=1#guide" target="_blank" title="Více"><img src="/images/guide-onboarding-3.png"></a>',
        description: '<b>Pozri sa, ako vyzerá onboarding pre zamestnanca (1 min).</b><br><br> V jednoduchom editore môžeš pripraviť stránku, ktorá sa zobrazí zamestnancom v <b>zvolený čas</b> (pred nástupom, 1. deň, atď.) na zvolenej pozícii.<br> Obsah môžeš doplniť podľa seba alebo môžeš použiť naše ready-made šablóny.',
        position: 'right-center',
        showButtons: true,
        doneBtnText: 'Áno, pokračovať ďalej',
        nextBtnText: 'Rozumiem',        // Next button text for this step
        prevBtnText: 'Späť',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/stranka?id=1&job=1#guide");

    }


},
]



export default onboardingChecklistSteps
